module.exports = __webpack_public_path__ + "static/media/text_container.3804d749.png";